import React from 'react';
import HFbutton from '../../button/HFbutton';
import TextWinds from '../../common/TextWinds';
interface TakeclassLinkButtonProps {
  id: string;
  openAction?: (id: string) => void;
}
const TakeclassLinkButton = ({ id, openAction }: TakeclassLinkButtonProps) => {
  return (
    <div className="m-auto w-[80px]">
      <HFbutton
        type="primary-outlined"
        onClick={() => openAction(id)}
        height={36}
      >
        <TextWinds type="button_text1" color="purple5">
          수업하기
        </TextWinds>
      </HFbutton>
    </div>
  );
};

export default TakeclassLinkButton;
